<template>
    <el-dialog  :title="title" :visible.sync="showBlock" :destroy-on-close="true" width="450px" :before-close="closedBtn">
        <el-form :model="formDate" ref="formDate" label-width="80px" class="demo-ruleForm">
            <el-form-item  label="目录" prop="dictText">
                <TReeBlock keyVal="parentId" ref="parentId" :options="menuList" width="330" childKey="children" @getVal="getVal"/>
            </el-form-item>
            <div class="common-items-center common-space-between">
                <el-form-item v-if="formDate.mark*1==2" label="类型" prop="dictText" :rules="[{required:true,message:'类型不能为空'}]">
                    <div style="width:179px">
                        <el-input  v-model="formDate.dictText" maxlength="30" placeholder="请输入字典数据文本" autocomplete="off"></el-input>
                    </div>    
                </el-form-item>
                <el-form-item  v-else label="类型" prop="dictNumber" :rules="[{required:true,message:'类型不能为空'}]">
                    <div style="width:179px">
                        <el-input  v-model="formDate.dictNumber" maxlength="30" type="number" placeholder="请输入数字" autocomplete="off"></el-input>
                    </div>    
                </el-form-item>
                 <div class="warp-radio">
                    <el-radio-group v-model="formDate.mark">
                        <div class="common-items-center">
                            <el-radio label="2">文本</el-radio>
                            <el-radio label="1">数字</el-radio>
                        </div>
                    </el-radio-group>
                </div>
            </div>
            <div class="common-items-center common-space-between">
                <el-form-item  label="排序" prop="descr">
                    <el-input-number v-model="formDate.orderNo" controls-position="right" :min="1" :max="maxNo"></el-input-number>
                </el-form-item>
                 <div class="warp-radio">
                    <el-radio-group v-model="formDate.state">
                        <el-radio label="1">启用</el-radio>
                        <el-radio label="0">禁用</el-radio>
                    </el-radio-group>
                </div>
            </div>
            <el-form-item  label="描述" prop="descr">
                <el-input
                    type="textarea"
                    :rows="2"
                    placeholder="请输入内容"
                    v-model="formDate.remarks">
                    </el-input>
            </el-form-item>
            <div class="warp-btn">
                <el-form-item>
                    <div  class="dialog-footer">
                        <el-button @click="closedBtn">取消</el-button>
                        <el-button type="primary" @click="submitForm('formDate')">提交</el-button>
                    </div>
                </el-form-item>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
  import {url,operate} from '@/utils/config'
  import {postFun,putFun} from '@/utils/httpFun'
  import TReeBlock from '@/components/component-block/block-newTree.vue'
  export default{
     components:{
        TReeBlock:TReeBlock
     },
     data(){
       return{
            title:"",
            menuList:[],
            maxNo:0,
            parentId:0,
            formDate: {
                dictText:"",
                dictNumber:null,
                orderNo:1,
                remarks:"",
                mark:"2",
                state:"1",
            },
            showBlock: false
        }
     },
    
     created(){
       
     },
     methods:{
        
        //获取下拉的值
        getVal(ev){
           this.parentId = ev.val.id
        },

        //重置输入框信息
        resetForm(formDate) {
            this.$refs[formDate].resetFields();
        },

        //提交
        submitForm(formDate) {
            this.$refs[formDate].validate((valid) => {
            if (valid) {
                  this.submitAdd()
                } else {
                  console.log('error submit!!');
                  return false;
                }
            });
        },

        //提交新增
        async submitAdd(){
            console.log(this.formDate.text*1==1)
            let parms = {
                dtId:this.dtId,
                orderNo:this.formDate.orderNo,
                state:this.formDate.state,
                remarks:this.formDate.remarks,
                type:this.formDate.mark,   //1数字 2文本
                parentId:this.parentId,    //父ID
                dictNumber: this.formDate.mark*1==1 ? this.formDate.dictNumber*1:"",
                dictText:this.formDate.mark*1==2 ?  this.formDate.dictText:""
            }
            await postFun(operate.DICTIONARYTADD,parms,res=>{
               this.$parent.getList()
               this.showBlock = false     
            })
        },

        //开启弹窗
        showBlockMe(ev){
           this.menuList = [...[{id:"0",name:"主目录"}],...ev.treeList]
           this.maxNo = ev.maxNo*1+1
           this.dtId =  ev.id
           this.title =  ev.dtValue
           this.showBlock = true 
           this.formDate.dictText = ""
           this.formDate.dictNumber = null
           this.formDate.remarks = ""
           this.$nextTick(res=>{
               this.$refs.parentId.setVal("0")
           })
        },
        
        //关闭弹窗并刷新
        closedBtn(){
            this.showBlock = false
        }
     }
  }
</script>
<style scoped lang="scss">
   .dialog-footer{
       display: flex;
       justify-content: flex-end;
   }

   .name{
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #4D5C72;
        letter-spacing: 0;
   }
   .warp-radio{
     position: relative;
     bottom: 10px;
   }


   .warp-btn{
    .el-form-item {
        margin-bottom:0px!important;
     }
   }
   
</style>